import * as React from "react";

import {
	List,
	Datagrid,
	ListProps,
	DateField,
	TextField,
	useGetIdentity,
	FunctionField,
	TopToolbar,
	ResourceContextProvider,
	useNotify,
} from "react-admin";
import axios from "axios";
import Pagination from "../Components/Pagination";

type TSendSMS = {
	patientId: string;
	patient: {
		firstName: string;
		lastName: string;
	};
	doctor: {
		firstName: string;
		lastName: string;
	};
	patientPhoneNumber: string;
};

const ListActions = () => (
	<TopToolbar>
		{/* <CreateButton
			label={`ثبت اطلاعات ${labelsTranslation.userList.createButton}`}
		/> */}
	</TopToolbar>
);

export const PatientList = (props: ListProps): React.ReactElement => {
	const { identity, loaded } = useGetIdentity();
	const notify = useNotify();
	const [sendSMSLoading, setSendSMSLoading] = React.useState(false);
	const [buttonID, setButtonID] = React.useState<string | null>(null);
	const handleSMSClick = (e: any, sendSMSInfo: TSendSMS) => {
		const { patientId } = sendSMSInfo;
		e.stopPropagation();
		setButtonID(patientId);
		setSendSMSLoading(true);

		axios({
			url: `${process.env.REACT_APP_SERVER_ADDRESS_8091}/api/patients/sendSaleSms`,
			method: "POST",
			headers: {
				"content-type": "application/json",
			},
			data: JSON.stringify(sendSMSInfo),
		})
			.then((res) => {
				setSendSMSLoading(false);
				notify("پیامک با موفقیت ارسال شد", "success");
			})
			.catch((err) => {
				setSendSMSLoading(false);
				notify("ارسال پیامک ناموفق بود", "error");
			});
	};
	const formatUserRole = (role: string) => {
		if (role === "doctor_sale.doctor") {
			return "پزشک";
		} else if (role === "sport_coach.coach") {
			return "مربی";
		} else {
			return "test";
		}
	};
	return (
		<>
			{loaded && (
				<>
					<ResourceContextProvider value="Patient">
						<List
							{...props}
							bulkActionButtons={false}
							perPage={50}
							actions={<ListActions />}
							pagination={<Pagination />}
							title={"لیست کاربران جدید"}
							filter={{
								// doctorId: {
								// 	equals: identity?.id,
								// },
								archived: {
									equals: false,
								},
							}}
						>
							<Datagrid rowClick="show">
								<FunctionField
									label={"نام و نام خانوادگی"}
									render={(record: any) =>
										`${record.firstName} ${record.lastName}`
									}
									sortable={false}
								/>
								<TextField label="موبایل" source="mobile" sortable={false} />
								<FunctionField
									label={"نام و نام خانوادگی ثبت کننده"}
									render={(record: any) => {
										return record.doctor
											? `${record.doctor.firstName} ${record.doctor.lastName}`
											: null;
									}}
									sortable={false}
								/>
								<TextField
									style={{
										whiteSpace: "pre-line",
									}}
									label={"توضیحات ثبت کننده"}
									source="doctorComment"
									sortable={false}
								/>
								<FunctionField
									label={"نقش ثبت کننده"}
									render={(record: any) => {
										return record.doctor
											? `${formatUserRole(record.doctor.role)}`
											: null;
									}}
									sortable={false}
								/>
								<FunctionField
									label={"ارسال پیامک دارای لینک"}
									render={(record: any) => (
										<button
											disabled={sendSMSLoading && buttonID === record.id}
											onClick={(e) =>
												handleSMSClick(e, {
													patientId: record.id,
													patient: {
														firstName: record.firstName,
														lastName: record.lastName,
													},
													doctor: {
														firstName: record.doctor.firstName,
														lastName: record.doctor.lastName,
													},
													patientPhoneNumber: record.mobile,
												})
											}
										>
											{buttonID === record.id
												? !sendSMSLoading
													? "ارسال پیامک"
													: "در حال ارسال پیامک ..."
												: "ارسال پیامک"}
										</button>
									)}
									sortable={false}
								/>
								<TextField
									label="توضیحات اپراتور"
									source="saleRepresentativeComment"
								/>
								<DateField
									label="تاریخ ثبت"
									source="createdAt"
									locales={"fa-IR"}
								/>

								{/* <BooleanField label="ارشیو" source="archived" /> */}
								{/* <TextField label="Doctor" source="doctor.firstName" /> */}
								{/* <TextField label="Doctor Comment" source="doctorComment" /> */}
								{/* <TextField label="Doctor Id" source="doctorId" /> */}

								{/* <TextField label="نام" source="firstName" /> */}
								{/* <TextField label="نام خانوادگی" source="lastName" /> */}
								{/* <TextField label="ID" source="id" /> */}
							</Datagrid>
						</List>
					</ResourceContextProvider>
				</>
			)}
		</>
	);
};
